/**
 * Badge Component
 * 상태 표시용 배지 컴포넌트
 */
import React from "react";
import { CONTRACT_STATUS, isActiveStatus } from '@/shared/constants/contractStatus.constants';

type BadgeVariant = 'success' | 'danger' | 'info' | 'neutral' | 'warning' | 'error';

interface BadgeProps {
    variant: BadgeVariant;
    children: React.ReactNode;
    className?: string;
}

/**
 * 범용 배지 컴포넌트
 */
export const Badge: React.FC<BadgeProps> = ({ variant, children, className = '' }) => {
    return (
        <span className={`badge badge-${variant} ${className}`}>
            {children}
        </span>
    );
};

interface ContractBadgeProps {
    status: string;
}

/**
 * 계약 상태 배지 컴포넌트
 * @param status - 계약 상태 (UNDER_CONTRACT, TERMINATED_CONTRACT 등)
 */
export const ContractBadge: React.FC<ContractBadgeProps> = ({ status }) => {
    // 상태값을 한글로 변환
    const displayText =
        status === CONTRACT_STATUS.UNDER_CONTRACT ? '계약중' :
        status === CONTRACT_STATUS.TERMINATED_CONTRACT ? '계약종료' : status;

    return (
        <Badge variant={isActiveStatus(status) ? 'success' : 'danger'}>
            {displayText || '계약종료'}
        </Badge>
    );
};

interface PrepaymentBadgeProps {
    prepayment: boolean;
}

/**
 * 선정산 배지 컴포넌트
 * @param prepayment - 선정산 적용 여부
 */
export const PrepaymentBadge: React.FC<PrepaymentBadgeProps> = ({ prepayment }) => {
    return (
        <Badge variant={prepayment ? 'info' : 'neutral'}>
            {prepayment ? '적용' : '미적용'}
        </Badge>
    );
};
